import React from 'react';
import AssignmentInd from '@material-ui/icons/AssignmentInd';
import DashboardIcon from '@material-ui/icons/Dashboard';
import DonutIcon from '@material-ui/icons/DonutSmall';

import { generateAdUrl } from 'services/adServices/popUpAdService/constants';
import { MINUTE_AS_MILLISECONDS } from 'enum/timeFormat';
import { GENDER } from 'enum/profile';


export const BANNERS_CONST = {
  STUDIO: 'studio',
  USERNAME: 'username',
  IDENTITIES: 'identities',
  ONBOARD: 'onboard',
};

export const SEX_PREFERENCE = {
  male: 'MALES',
  female: 'FEMALES',
  shemale: 'TRANS',
  couple: 'COUPLES',
  all: 'ALL',
};

export const TAGS_COUNT_GET_NEW = 8;

export const BODY_NO_PADDING = 'noPadding';
export const CAMS = 'cams';
export const COUPLE = 'couple';

export const DRAWER_MENU_ITEMS = [
  {
    icon: <DashboardIcon />,
    active: true,
    label: 'Dashboard',
    link: '/studio/dashboard',
    isStudio: true,
  },
  {
    icon: <AssignmentInd />,
    label: 'Roster',
    link: '/studio/roster',
    isStudio: true,
  },
  {
    icon: <DonutIcon />,
    label: 'Insights',
    link: '/studio/insights/earnings-report',
    isStudio: true,
  },
];

export const MOBILE_MENU = 'MOBILE_MENU';
export const FAVOURITES = 'FAVOURITES';
export const ACCOUNT_MENU = 'ACCOUNT_MENU';
export const FILTERS_MENU = 'FILTERS_MENU';
export const QUICK_FILTERS_MENU = 'QUICK_FILTERS_MENU';
export const TAGS_DRAWER = 'TAGS_DRAWER';

export const AUTH_TYPE = {
  STUDIO: 'studio',
  ADMIN: 'admin',
};

export const FILTER_CATEGORIES = {
  genders: 'gender',
  bodyTypes: 'bodyType',
  transBodyTypes: 'transBodyType',
  ethnicities: 'ethnicity',
  bodyHairs: 'bodyHair',
  showTypes: 'showType',
  sexPreferences: 'sexPreference',
  hairColors: 'hairColor',
  breastSizes: 'breastSize',
  broadcastType: 'broadcastType',
  languages: 'language',
  countries: 'country',
  femaleTypes: 'femaleType',
  femaleBodyTypes: 'femaleBodyType',
  maleBodyTypes: 'maleBodyType',
  penisSizes: 'penisSize',
  penisTypes: 'penisType',
  maleTypes: 'maleType',
  maleRoles: 'maleRole',
  transTypes: 'transType',
  transPenisSizes: 'transPenisSize',
  transBreastSizes: 'transBreastSize',
  transPenisTypes: 'transPenisType',
  regionals: 'regionals',
};

export const QUICK_FILTERS = {
  newPerformer: 'newPerformer',
  friends: 'friends',
  favorites: 'favorites',
};

export const SHOW_TYPE_ADDITIONAL_FILTERS = {
  kiiroo: 'kiiroo',
  hd: 'hd',
  source: 'source',
  c2cAllowed: 'c2cAllowed',
};

export const REQUEST_STATUS = {
  NONE: 'none',
  SUCCESS: 'success',
  IN_PROGRESS: 'in_progress',
  FAIL: 'fail',
  FAILED: 'failed',
};

export const PERFORMER_HUB_PAGES = {
  cashOut: 'cashOut',
  earningsHistory: 'earningsHistory',
  ageVerification: 'ageVerification',
  dashboard: 'dashboard',
};

const AD_ID_PORN_GAMES_DESKTOP_STRAIGHT = 242;
const AD_ID_PORN_GAMES_DESKTOP_GAY = 244;
const AD_ID_PORN_GAMES_DESKTOP_TRANS = 246;
const AD_ID_PORN_GAMES_MOBILE_STRAIGHT = 248;
const AD_ID_PORN_GAMES_MOBILE_GAY = 250;
const AD_ID_PORN_GAMES_MOBILE_TRANS = 252;

export const PORN_GAMES_PAGES = {
  desktopStraight: generateAdUrl(AD_ID_PORN_GAMES_DESKTOP_STRAIGHT),
  desktopGay: generateAdUrl(AD_ID_PORN_GAMES_DESKTOP_GAY),
  desktopTrans: generateAdUrl(AD_ID_PORN_GAMES_DESKTOP_TRANS),
  mobileStraight: generateAdUrl(AD_ID_PORN_GAMES_MOBILE_STRAIGHT),
  mobileGay: generateAdUrl(AD_ID_PORN_GAMES_MOBILE_GAY),
  mobileTrans: generateAdUrl(AD_ID_PORN_GAMES_MOBILE_TRANS),
};

const AD_ID_LOCAL_DATES_DESKTOP_STRAIGHT = 230;
const AD_ID_LOCAL_DATES_DESKTOP_GAY = 232;
const AD_ID_LOCAL_DATES_DESKTOP_TRANS = 234;
const AD_ID_LOCAL_DATES_MOBILE_STRAIGHT = 236;
const AD_ID_LOCAL_DATES_MOBILE_GAY = 238;
const AD_ID_LOCAL_DATES_MOBILE_TRANS = 240;

export const LOCAL_DATES_PAGES = {
  desktopStraight: generateAdUrl(AD_ID_LOCAL_DATES_DESKTOP_STRAIGHT),
  desktopGay: generateAdUrl(AD_ID_LOCAL_DATES_DESKTOP_GAY),
  desktopTrans: generateAdUrl(AD_ID_LOCAL_DATES_DESKTOP_TRANS),
  mobileStraight: generateAdUrl(AD_ID_LOCAL_DATES_MOBILE_STRAIGHT),
  mobileGay: generateAdUrl(AD_ID_LOCAL_DATES_MOBILE_GAY),
  mobileTrans: generateAdUrl(AD_ID_LOCAL_DATES_MOBILE_TRANS),
};

export const SFW_PORN_GAMES_PAGES = {
  desktopStraight: '//a.libertystmedia.com/loader?a=1009&s=5&t=undefined&p=4',
  desktopGay: '//a.libertystmedia.com/loader?a=1010&s=5&t=undefined&p=4',
  desktopTrans: '//a.libertystmedia.com/loader?a=1011&s=5&t=undefined&p=4',
  mobileStraight: '//a.libertystmedia.com/loader?a=1020&s=5&t=undefined&p=4',
  mobileGay: '//a.libertystmedia.com/loader?a=1021&s=5&t=undefined&p=4',
  mobileTrans: '//a.libertystmedia.com/loader?a=1022&s=5&t=undefined&p=4',
};

export const SFW_LOCAL_DATES_PAGES = {
  desktopStraight: '//a.libertystmedia.com/loader?a=1017&s=5&t=undefined&p=4',
  desktopGay: '//a.libertystmedia.com/loader?a=1018&s=5&t=undefined&p=4',
  desktopTrans: '//a.libertystmedia.com/loader?a=1019&s=5&t=undefined&p=4',
  mobileStraight: '//a.libertystmedia.com/loader?a=1023&s=5&t=undefined&p=4',
  mobileGay: '//a.libertystmedia.com/loader?a=1024&s=5&t=undefined&p=4',
  mobileTrans: '//a.libertystmedia.com/loader?a=1025&s=5&t=undefined&p=4',
};

export const ACCOUNT_SETTINGS_PAYMENTS = {
  card: 'CARD',
  token: 'TOKEN',
  reactivate: 'REACTIVATE',
  terminate: 'TERMINATE',
};

export const MY_LIBRARY_FILTERS = {
  TITLE: 'title',
  PERFORMER: 'performer',
  TAGS: 'tags',
  MOST_RECENT: 'date',
  DURATION: 'duration',
  APLPHABETICAL: 'title',
  LIBRARY_SORT_VIDEOS: 'library-sort-videos',
  PRIORITY: 'priority',
  DATE_ADDED: 'date_added',
  PRICE: 'cost',
  LONGEST: '-duration',
};

export const TAGS_DEFAULT_COUNT = 25;
export const TAGS_DEFAULT_INDEX = 0;

export const GENDER_PREFERENCE_REGEX =
  // eslint-disable-next-line max-len
  '(|/|male|female|transgender|cams|couple|all|homme|femme|manner|frauen|paare|chicos|chicas|parejas|ragazzi|donne|coppie|barbati|femei|transexuali|cupluri|mannen|vrouwen|koppels|killar|tjejer|transpersoner|par|homens|mulheres|casais)';
export const REGEX_ALPHA_WITH_SPACE = /^[a-zA-Z ]+$/;
export const REGEX_ALPHA_AND_CARET_DASH = /^[a-zA-Z'-]+$/;
export const REGEX_ALPHA_AND_DIGITS_WITH_SPACE = /^[a-zA-Z0-9 ]+$/;
export const REGEX_ALPHA_AND_DIGITS_WITH_SPECIAL_CHARS = /^[a-zA-Z0-9&.#/,'\- ]+$/;
export const REGEX_ALPHA_AND_DIGITS_WITH_HYPHEN = /^[a-zA-Z0-9- ]+$/;
export const CAPTCHA_SITE_KEY = '6LdcLiITAAAAAEcLyvDqDYHjlrqkSABPLIL5MjhO';
export const POPULAR_CAMS_REGEX =
  // eslint-disable-next-line max-len
  '/(usa-cams|germany-cams|brazil-cams|italy-cams|cams/spain|cams/uk|cams/france|english-webcams|german-webcams|cams/spanish|cams/portuguese|cams/italian|french-webcams)/';
export const REGEX_PRINTABLE_ASCII_CODE = /^[ -~]+$/;
export const REGEX_NO_CONSECUTIVE_SPACES = / +(?= )/g;
export const REGEX_CLEAR_PASSWORD_CHARACTERS = /[^a-zA-Z0-9!#$%&()*+,.:;<>=?@^_{|}[\]]/gi;
export const REGEX_CLEAR_PASSWORD_CHARACTERS_TAGS = /[^a-zA-Z0-9-!#$%&()*+,.:;<>=?@^_{|}[\]]/gi;
export const PASSWORD_MATCH_REGEX = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*[!#$%&()*+,.:;<>=?@^_{|}[\]0-9]).{6,128}$/;
export const PASSWORD_UPPERCASE_LETTER = /^(?=.*?[A-Z])/;
export const PASSWORD_LOWERCASE_LETTER = /^(?=.*?[a-z])/;
export const PASSWORD_SPECIALCHAR_REGEX = /^(?=.*[!#$%&()*+,.:;<>=?@^_{|}[\]0-9])/;
export const PASSWORD_ILLEGAL_CHARS = /^(?=.*^[!#$%&()*+,.:;<>=?@^_{|}[\]0-9a-zA-Z]+$).{6,128}$/;
export const SOCIAL_INPUTS_REGEX = /^[a-zA-Z0-9-_.']+$/;
export const PASS_REC_EMAIL_SENT = 'pass_rec_email_sent';
export const WEAK_PASSWORD = 'WEAK_PASSWORD';

export const PARSED_CHECKING_FOR_CRAWLERS = window.IS_BOT;

export const DIRECTORY_CAMS_ALIASES =
  // eslint-disable-next-line max-len
  '/(live-sex|sexe-live|sesso-live|webcam-sexo|sex-cams|cam-sexe|cam-sesso|sex-chat|chat-sexe|chat-porno|chat-sexo|free-sex|cam-gratuit|chat-gratis|sex-gratis|gratis-sex|cam-chat|chat-cam|erotik-cam-chat|webcam-chat|sex-video-chat|sexe-video-chat|videochat-sesso|video-chat|sex-video-chat|video-sex-chat|webcam-shat|porn-chat|porn-chat|chat-porno|videochat-porno|porno-chat|live-porno-chat|porn-chatt|xxx-live|cam-xxx-live|cam-xxx|webcam-xxx|xxx-live|adult-cams|cam-x|cam-adulti|webcam-adultos|erwachsenen-cams|webcam-sex|vuxna-cams|nude-cams|cam-nu|nude-cam|cam-chicas-desnudas|amateur-cams|webcam-amateur|webcam-amatoriali|cam-amateur|amatör-porr|fuck-cams|fick-cams|cam-porno|cam-scopate|webcam-follada|knulla-cam)';
export const INVALID_PASSWORD = 'invalid_password';
export const USER_NOT_FOUND = 'user_not_found';
export const CODE_INVALID = 'code_invalid';
export const SECURITY_CODE_MISSING = 'security_code_missing';
export const SECURITY_CODE_EXPIRED = 'security_code_expired';
export const USER_BANNED = 'user_banned';
export const PASSWORD_CHANGE_FAILED = 'password_change_failed';
export const IDENTICAL_PASSWORDS = 'identical_password';
export const TOKEN_RANGE = {
  LOWEST_SOUND_TOKEN_AMOUNT: 5,
  LOW_SOUND_TOKEN_AMOUNT: 10,
  MIDDLE_SOUND_TOKEN_AMOUNT: 50,
  HIGH_SOUND_TOKEN_AMOUNT: 250,
};
export const SENT_CHAT_MESSAGE_STATUSES = {
  NOT_ALLOWED_TO_CHAT_WITHOUT_TOKENS: 'NOT_ALLOWED_TO_CHAT_WITHOUT_TOKENS',
  BROADCASTERS_NOT_ALLOWED_TO_CHAT: 'BROADCASTERS_NOT_ALLOWED_TO_CHAT',
  THROTTLER_MESSAGE_SPAM: 'THROTTLER_MESSAGE_SPAM',
  THROTTLER_TOO_MANY_MESSAGES: 'THROTTLER_TOO_MANY_MESSAGES',
  GENDER_NOT_ALLOWED_TO_CHAT: 'GENDER_NOT_ALLOWED_TO_CHAT',
  USER_LANGUAGE_NOT_ALLOWED_TO_CHAT: 'USER_LANGUAGE_NOT_ALLOWED_TO_CHAT',
  ONLY_FRIENDS_FAVORITES_ALLOWED_TO_CHAT: 'ONLY_FRIENDS_FAVORITES_ALLOWED_TO_CHAT',
  THROTTLER_MUST_WAIT: 'THROTTLER_MUST_WAIT',
  SPAM_DETECTED: 'Spam detected',
  EMPTY_MESSAGE: 'EMPTY_MESSAGE',
  GUEST_OR_SILENCED_USERS_NOT_ALLOWED_TO_CHAT: 'GUEST_OR_SILENCED_USERS_NOT_ALLOWED_TO_CHAT',
  NOT_IN_THE_ROOM: 'notInTheRoom',
  COULD_NOT_PARSE_GIPHY_URL: 'COULD_NOT_PARSE_GIPHY_URL',
  GIPHY_SENT_TOO_SOON: 'GIPHY_SENT_TOO_SOON',
  ROOM_INVALID_OR_NOT_ONLINE: 'roomInvalidOrNotOnline',
};
export const SOUND_NOTIFICATION_TYPES = {
  TIER_1: 'tier1',
  TIER_2: 'tier2',
  TIER_3: 'tier3',
  TIER_4: 'tier4',
  GAME: 'game',
  BOOST: 'boost',
  ROLL_THE_DICE: 'rollTheDice',
  SPIN_THE_WHEEL: 'spinTheWheel',
  TOKEN_KENO: 'tokenKeno',
  SPIN_THE_WHEEL_END: 'spinTheWheelEnd',
  TOKEN_KENO_END: 'tokenKenoEnd',
  GHOST_SOUND: 'ghostSound',
  PRIVATE_SHOW_REQUEST_SOUND: 'privateShowRequestSound',
  PRIVATE_MESSAGE_SOUND: 'privateMessageSound',
};

const INITIAL_DELAY_TIME = 5;
const DELAY_REPEAT_TIME = 2.5;

export const SHOW_REGISTRATION_MODAL_AFTER_ENTERING_CAM = INITIAL_DELAY_TIME * MINUTE_AS_MILLISECONDS;
export const SHOW_REGISTRATION_MODAL_REPEAT = DELAY_REPEAT_TIME * MINUTE_AS_MILLISECONDS;
export const SHORT_SHOW_REGISTRATION_MODAL_AFTER_ENTERING_CAM = 90000;

export const GIFT_GOLD_STAR_NOTIFICATION_EXTRA = 415;

export const USER_MODALS_GROUP = {
  PROFILE_FEEDBACK: 'PROFILE_FEEDBACK',
  FRIENDS_FAVORITES_TOOLTIP: 'FRIENDS_FAVORITES_TOOLTIP',
  ZOOM_IN_TOOLTIP: 'ZOOM_IN_TOOLTIP',
  HIDE_CHAT_TOOLTIP: 'HIDE_CHAT_TOOLTIP',
  COOKIES_POLICY_UPDATED: 'COOKIES_POLICY_UPDATED',
  BWR_TUTORIAL: 'BWR_TUTORIAL',
};

export const GOLD_GIFT_CATEGORY = 34;

export const GET_UI_VARIABLES_TIME = 300000;
export const FORCE_PROFILE_V2_REFRESH = 60000;
// pixels
export const MEDIA_BREAKPOINT_MOBILE_DOWN = 767;
export const MEDIA_BREAKPOINT_TABLET_DOWN = 1024;
export const PAYPAL_STATUS = {
  BROADCAST_APPROVED: 'BROADCAST_APPROVED',
  NONE: 'NONE',
  APPROVED_2257: 'APPROVED_2257',
  CASH_OUT_APPROVED: 'CASH_OUT_APPROVED',
};
export const MODERATION_DRAWER_NAMES = {
  MODERATORS: 'moderators',
  BANS: 'bans',
  SILENCES: 'silences',
};
export const BROADCASTER_LIVE_TOUCH_OPERATIONS = {
  JOIN_ROOM: 'JOIN_ROOM',
  LEAVE_ROOM: 'LEAVE_ROOM',
};
export const BOOST_ERRORS = {
  INSUFFICIENT_FUNDS: 'INSUFFICIENT_FUNDS',
  EARNINGS_LOCKED: 'EARNINGS_LOCKED',
  ROOM_ALREADY_BOOSTED: 'ROOM_ALREADY_BOOSTED',
};

export const PRIVATE_SHOW_TABS = {
  PER_MINUTE: 0,
  FIXED_RATE: 1,
  SOLO_PRIVATE: 2,
};

export const GROUPSHOW_ACTIONS = {
  SELLING_GS_TICKETS: 'sellGSTickets',
  END_GS: 'endGS',
  START_GS: 'startGS',
  UPDATE_GS_TICKETS: 'updateGSTickets',
};

export const PS_SETTINGS_ACTIONS = {
  GET: 'getPSSettings',
  UPDATE: 'updatePSSettings',
};

export const RATING_TYPE = { VIEWER: 'VIEWER' };

export const USER_LEVELS = [
  { type: 'ALL', label: 'Any Access Level' },
  { type: 'GOLD', label: 'Gold Members' },
  { type: 'BASIC', label: 'Basic Members' },
  { type: 'GUEST', label: 'Guests' },
];

export const USER_TYPES = [
  { type: 'ALL', label: 'Any User Type' },
  { type: 'PERFORMER', label: 'Performers only' },
  { type: 'VIEWER', label: 'Viewers only' },
];

export const SEXUAL_PREFERENCES = [
  { type: 'ANY', label: 'Any content preference' },
  { type: 'FEMALES', label: 'Females' },
  { type: 'MALES', label: 'Males' },
  { type: 'TRANS', label: 'Trans' },
  { type: 'COUPLES', label: 'Couples' },
  { type: 'ALL', label: 'All' },
];
export const PURCHASED_STATUSES = [
  { type: 'ALL', label: 'Any Purchase Behaviour' },
  { type: 'HAS_PURCHASED', label: 'Has purchased tokens' },
  { type: 'HAS_NOT_PURCHASED', label: 'Has not purchased tokens' },
];

export const ADS_FOR_GENDERS = {
  mobile: {
    [GENDER.FEMALE]: 'mobileStraight',
    [GENDER.MALE]: 'mobileGay',
    [GENDER.SHEMALE]: 'mobileTrans',
    [GENDER.TRANSGENDER]: 'mobileTrans',
    DEFAULT: 'mobileStraight',
  },
  tablet: {
    [GENDER.FEMALE]: 'desktopStraight',
    [GENDER.MALE]: 'desktopGay',
    [GENDER.SHEMALE]: 'desktopTrans',
    [GENDER.TRANSGENDER]: 'desktopTrans',
    DEFAULT: 'desktopStraight',
  },
};

export const MANDATORY_FIELDS_FOR_CREATE = 'Please input all mandatory fields! (image, title, body, header link)';
export const MANDATORY_FIELDS_FOR_UPDATE = 'Please input all mandatory fields! (title, body, header link)';

export const SIGN_UP_TYPE = {
  FANCLUB: 'FAN_CLUB_SIGN_UP',
  GOLD: 'GOLD_SIGN_UP',
};
